{
  "archetype": "generic",
  "blockType": "card-product",
  "contentHash": "96efef007543743531231ce46c5def199152181193363add38dd6a206492c840",
  "description": "E-commerce product card grid with image, title, price with strikethrough original price, star rating, and add-to-cart button. Hover scale effect.",
  "files": {
    "block": "block.cogo.json",
    "datasource": "datasource.cogo.json",
    "events": "events.cogo.json",
    "flow": "flow.cogo.json",
    "ui": "ui.cogo.json",
    "variables": "variables.cogo.json"
  },
  "generatedAt": "2026-04-25T02:24:03.428Z",
  "lifecycle": {
    "onMount": "cardProductMount"
  },
  "metadata": {
    "author": "cogo",
    "category": "card",
    "id": "card-product",
    "qualityTier": "golden",
    "tags": [
      "card",
      "product",
      "ecommerce",
      "price",
      "rating",
      "shopping",
      "grid",
      "hover"
    ]
  },
  "name": "card-product",
  "permissions": {
    "forkable": true,
    "remixable": true,
    "visibility": "public"
  },
  "schemaVersion": "4.0",
  "socialMetadata": {
    "commentCount": 0,
    "fireCount": 0,
    "forkCount": 0
  },
  "stateContract": {
    "inputSymbols": [],
    "localState": {},
    "outputSymbols": []
  },
  "type": "ui",
  "version": "2.0.0"
}
